import services from './theme.services'
import { GeneralThemeAndControls } from './types'

export async function getThemeByUniqueCode(
  uniqueCode: string,
  theme: GeneralThemeAndControls,
): Promise<GeneralThemeAndControls> {
  let clinicColors = theme

  try {
    clinicColors = await services.getClinicColorsByUniqueCode(uniqueCode)
  } catch (e) {
    console.log(e)
  }

  return clinicColors
}
